import React from 'react';
import PageTitle from '../Shared/PageTitle/PageTitle';


const About = () => {
    return (
        <div style={{minHeight: '60vh'}} className='container bg-info ps-5 pe-5 pt-5 mt-5 rounded'>
            <PageTitle title='About'></PageTitle>
            
            <h2 className='text-center mt-5'>Hello there!</h2>
            
            <h5 className='mt-2 p-2'>I'm <span className='text-danger'>SpeedBird</span>, an engineering student trying to ride my luck somewhere on this planet. Thanks for coming to my TEDTalk :)  </h5>
        </div>
        
    );
};

export default About;